import * as React from "react";
import PropTypes from "prop-types";

export default class Circle extends React.PureComponent {

  static propTypes = {
    "answer": PropTypes.object.isRequired,
    "onAnswer": PropTypes.func.isRequired,
    "surveyFields": PropTypes.object.isRequired
  };

  handleClick = () => {
    const {"answer": {surveyFields}, onAnswer} = this.props;
    onAnswer(surveyFields, this.isSelected());
  };

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleClick();
    }
  }

  isSelected = () => {
    const {
      "answer": {"surveyFields": answerFields},
      surveyFields
    } = this.props;
    let selected = true;

    for (const answerField of Object.entries(answerFields)) {
      const key = answerField.shift();
      const value = answerField.shift();
      if (value !== surveyFields[key]) {
        selected = false;
      }
    }

    return selected;
  };

  render () {
    const {answer} = this.props;
    const selectedClass = this.isSelected() ? "selected" : "";

    return (
      <div
        className={`${selectedClass} circle`}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        tabIndex="0"
        title={answer.prompt}
      >
        <div>
          {answer.prompt}
        </div>
      </div>
    );
  }
}
